module.exports = __webpack_public_path__ + "img/tassie1.b8a4a7d.jpg";